import { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, ToolTip } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ColoredTooltipTitle } from "../../../Constants/Constants";
import { ColorTooltipData, ColoredTooltipSubTitle } from "../../../Data/UiKits/Tooltip";

const ColoredTooltip = () => {
  const [openIndex, setOpenIndex] = useState(-1);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? -1 : index);

  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={ColoredTooltipTitle} span={ColoredTooltipSubTitle} />
        <CardBody>
          <div className="common-flex">
            {ColorTooltipData &&
              ColorTooltipData.map((item, index) => (
                <Fragment key={index}>
                  <Btn color={item.class} id={`color_${index}`} onClick={() => toggleTooltip(index)}>
                    {item.text}
                  </Btn>
                  <ToolTip isOpen={openIndex === index} target={`color_${index}`} toggle={() => toggleTooltip(index)}>
                    {item.text}
                  </ToolTip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ColoredTooltip;
